module.exports = __webpack_public_path__ + "static/media/uitools.28a9d88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/images/uitools.png
// module id = 534
// module chunks = 8